<div class="section-loader body-bg" *ngIf="loading">
  <div class="loader-inner ball-beat">
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
<div class="scroll page-bg flex-fill overflow-auto py-3 px-5 centerform">
  <div class="container p-0">
    <form [formGroup]="schoolForm" (ngSubmit)="updateSchool(schoolForm.value)">
      <div class="mControls">
        <div class="input-group mr-auto">
          <h1 class="m-0 text-white align-items-center d-inline-flex">
            {{
              editSchool
                ? "Update " + schoolToEdit?.school_name
                : "Create New School"
            }}
          </h1>
        </div>
        <div class="mControls__right">
          <div class="input-group">
            <button
              type="button"
              mat-raised-button
              (click)="navigateToSchoolDirectory()"
            >
              Cancel
            </button>
          </div>
          <div class="input-group">
            <button
              mat-raised-button
              color="primary"
              [disabled]="!schoolForm.valid"
            >
              Done
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-7 mb-3">
          <div class="card">
            <div class="card-header">General</div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>School Id</mat-label>
                    <input
                      placeholder="School Id"
                      matInput
                      name="schoolid"
                      id="schoolid"
                      type="text"
                      formControlName="uuid"
                      maxlength="100"
                      required
                    />
                    <mat-error
                      *ngIf="schoolForm.get('uuid').hasError('required')"
                      >School Id is required</mat-error
                    >
                    <mat-error
                      *ngIf="schoolForm.get('uuid').hasError('pattern')"
                      >Invalid School Id</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>School Name</mat-label>
                    <input
                      placeholder="School Name"
                      matInput
                      name="schoolname"
                      id="schoolname"
                      type="text"
                      formControlName="school_name"
                      maxlength="100"
                      required
                    />
                    <mat-error
                      *ngIf="schoolForm.get('school_name').hasError('required')"
                      >School Name is required</mat-error
                    >
                    <mat-error
                      *ngIf="schoolForm.get('school_name').hasError('pattern')"
                      >Invalid School Name</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-md-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Street Address</mat-label>
                    <input
                      placeholder="Street Address"
                      matInput
                      name="address"
                      id="address"
                      type="text"
                      formControlName="school_address"
                      maxlength="255"
                      required
                    />
                    <mat-error
                      *ngIf="
                        schoolForm.get('school_address').hasError('required')
                      "
                      >Street Address is required</mat-error
                    >
                    <mat-error
                      *ngIf="
                        schoolForm.get('school_address').hasError('pattern')
                      "
                      >Invalid Street Address</mat-error
                    >
                  </mat-form-field>
                </div>

                <div class="col-md-4">
                  <mat-form-field appearance="outline">
                    <mat-label>City</mat-label>
                    <input
                      placeholder="City"
                      matInput
                      name="school_city"
                      id="school_city"
                      type="text"
                      formControlName="school_city"
                      maxlength="50"
                      required
                    />
                    <mat-error
                      *ngIf="schoolForm.get('school_city').hasError('required')"
                    >
                      City is required</mat-error
                    >
                    <mat-error
                      *ngIf="schoolForm.get('school_city').hasError('pattern')"
                      >Invalid City</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>State</mat-label>
                    <mat-select formControlName="stateId" required>
                      <mat-option
                        *ngFor="let schoolstate of states"
                        [value]="schoolstate.id"
                      >
                        {{ schoolstate.state_name }}
                      </mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="schoolForm.get('stateId').hasError('required')"
                      >State is required</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Zip Code</mat-label>
                    <input
                      mask="00000"
                      placeholder="5-Digit-Number"
                      matInput
                      name="school_zip"
                      id="school_zip"
                      formControlName="school_zip"
                      min="10000"
                      required
                    />
                    <mat-error
                      *ngIf="schoolForm.get('school_zip').hasError('required')"
                    >
                      Zip Code is required</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-md-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>School District</mat-label>
                    <mat-select
                      formControlName="districtId"
                      required
                      (selectionChange)="change()"
                    >
                      <mat-option>
                        <ngx-mat-select-search
                          style="width: 100%"
                          [formControl]="districtControl"
                          [noEntriesFoundLabel]="'No matching district found'"
                          placeholderLabel="Search District"
                        >
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option
                        *ngFor="let schooldistrict of filteredDistricts"
                        [value]="schooldistrict.id"
                      >
                        {{ schooldistrict.district_name }}
                      </mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="schoolForm.get('districtId').hasError('required')"
                      >School District is required</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>School Phone Number</mat-label>
                    <input
                      mask="000 000-0000"
                      placeholder="ex.(555) 555-5555"
                      matInput
                      name="school_phone"
                      id="school_phone"
                      formControlName="school_phone"
                      required
                    />
                    <mat-error
                      *ngIf="
                        schoolForm.get('school_phone').hasError('required')
                      "
                      >School Phone Number is required</mat-error
                    >
                    <mat-error
                      *ngIf="schoolForm.get('school_phone').hasError('pattern')"
                      >Invalid Phone Number</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-md-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Principal Name</mat-label>
                    <input
                      placeholder="Principal Name"
                      matInput
                      name="principal_name"
                      id="principal_name"
                      type="text"
                      formControlName="principal_name"
                      maxlength="25"
                      required
                    />
                    <mat-error
                      *ngIf="
                        schoolForm.get('principal_name').hasError('required')
                      "
                      >Principal Name is required</mat-error
                    >
                    <mat-error
                      *ngIf="
                        schoolForm.get('principal_name').hasError('pattern')
                      "
                      >Invalid Name</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-md-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Vice Principal Name</mat-label>
                    <input
                      placeholder="Vice Principal Name"
                      matInput
                      name="vice_principal_name"
                      id="vice_principal_name"
                      type="text"
                      formControlName="vice_principal_name"
                      maxlength="25"
                      required
                    />
                    <mat-error
                      *ngIf="
                        schoolForm
                          .get('vice_principal_name')
                          .hasError('required')
                      "
                      >Vice Principal Name is required</mat-error
                    >
                    <mat-error
                      *ngIf="
                        schoolForm
                          .get('vice_principal_name')
                          .hasError('pattern')
                      "
                      >Invalid Name</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-md-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Adopted</mat-label>
                    <mat-select
                      formControlName="is_adopted"
                      (selectionChange)="isadopted($event)"
                      required
                    >
                      <mat-option
                        *ngFor="let item of adopted"
                        [value]="item.value"
                      >
                        {{ item.display }}
                      </mat-option>
                    </mat-select>
                    <mat-error
                      *ngIf="schoolForm.get('is_adopted').hasError('required')"
                      >Adopted is required</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-md-12" *ngIf="adoptedValue">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Tutor Limit for a student</mat-label>
                    <input
                      placeholder="Enter Number"
                      matInput
                      name="association_limit"
                      id="association_limit"
                      formControlName="association_limit"
                      [required]="adoptedValue"
                      (keypress)="checkForNumberValidation($event)"
                    />
                    <mat-error
                      *ngIf="
                        schoolForm.get('association_limit').hasError('required')
                      "
                      >Limit is required</mat-error
                    >
                    <mat-error
                      *ngIf="
                        schoolForm.get('association_limit').hasError('pattern')
                      "
                      >Invalid Limit
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Tutor Limit in the school</mat-label>
                    <input
                      placeholder="Slot Limit"
                      matInput
                      name="slot_limit"
                      id="slot_limit"
                      formControlName="slot_limit"
                      required
                      (keypress)="checkForNumberValidation($event)"
                    />
                    <mat-error
                      *ngIf="schoolForm.get('slot_limit').hasError('required')"
                      >Limit is required</mat-error
                    >
                    <mat-error
                      *ngIf="schoolForm.get('slot_limit').hasError('pattern')"
                      >Invalid Limit</mat-error
                    >
                    <mat-error
                      *ngIf="schoolForm.get('slot_limit').hasError('min')"
                      >Limit should be more than currently associated tutor
                      count</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-md-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Zoom link</mat-label>
                    <input
                      placeholder="Zoom link"
                      matInput
                      name="zoom_link"
                      id="zoom_link"
                      formControlName="zoom_link"
                    />
                  </mat-form-field>
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <div class="col-md-5 mb-3">
          <div class="card">
            <div class="card-header">School Contact</div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Name</mat-label>
                    <input
                      placeholder="Name"
                      matInput
                      name="clarity_person_name"
                      id="clarity_person_name"
                      type="text"
                      formControlName="clarity_person_name"
                      maxlength="25"
                      required
                    />
                    <mat-error
                      *ngIf="
                        schoolForm
                          .get('clarity_person_name')
                          .hasError('required')
                      "
                      >Name is required</mat-error
                    >
                    <mat-error
                      *ngIf="
                        schoolForm
                          .get('clarity_person_name')
                          .hasError('pattern')
                      "
                      >Invalid Contact Name</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-md-12">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Email</mat-label>
                    <input
                      placeholder="Email"
                      matInput
                      name="clarity_person_email"
                      id="clarity_person_email"
                      type="email"
                      formControlName="clarity_person_email"
                      required
                    />
                    <mat-error
                      *ngIf="
                        schoolForm
                          .get('clarity_person_email')
                          .hasError('required')
                      "
                      >Email is required</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-md-6">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Phone</mat-label>
                    <input
                      mask="000 000-0000"
                      placeholder="ex. (555) 555-5555"
                      matInput
                      name="clarity_person_phone"
                      id="clarity_person_phone"
                      formControlName="clarity_person_phone"
                      required
                    />
                    <mat-error
                      *ngIf="
                        schoolForm
                          .get('clarity_person_phone')
                          .hasError('required')
                      "
                      >Phone is required</mat-error
                    >
                    <mat-error
                      *ngIf="
                        schoolForm
                          .get('clarity_person_phone')
                          .hasError('pattern')
                      "
                      >Invalid Phone Number</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="col-md-12">
                  <mat-form-field
                    class="w-100 no-error"
                    appearance="outline"
                    class="w-100"
                  >
                    <mat-label>Notes</mat-label>
                    <textarea
                      name="Notes"
                      type="text"
                      matInput
                      name="notes"
                      id="notes"
                      formControlName="notes"
                      matInput
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      cdkAutosizeMinRows="8"
                      cdkAutosizeMaxRows="8"
                    ></textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
